import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { DeliveryOrderService, ConfigService } from 'app/services';
import { Utils } from 'app/utils';
import { StylesStatus } from 'app/models/users/StylesStatus';
import * as moment from 'moment/moment';
import {PayoutTransactionStatusEnum} from 'app/models/transaction/payout-transaction-status.enum';
import {MenuHomeEnum} from 'app/home';
import {MenuService} from 'app/finance/finance-payout/menu-service';
import {Subscription} from 'rxjs';
import {PayoutTransactionService} from 'app/services/payout-transaction.service';
import {PayoutTransactionOnlineTransferEnum} from 'app/models/transaction/payout-transaction-online-transfer.enum';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { OrderUtils } from 'app/utils/order-utils';
import { FieldTypeEnum } from 'app/models';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'finance-payout-online-transfer',
    templateUrl: './finance-payout-online-transfer.component.html',
    styleUrls: ['./finance-payout-online-transfer.component.scss',
        '../../../../../styles/paginator.scss'],
    providers: [MessageService]
})

export class FinancePayoutOnlineTransferComponent implements OnInit, OnDestroy  {
    @Input()
    public menuPermissionActive!: string;

    @Input()
    public onboardingTabMenu: Array<any> = [];

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public payoutTransactions: Array<any> = [];
    public rowsPerPage: number = 10;
    public totalRecords: number = -1;
    public fieldTypeEnum = FieldTypeEnum;
    public paginator: Paginator = new Paginator();
    public visibleTransactionsFilter: boolean = false;
    public visibleTransactionsSettings: boolean = false;
    public filterObj: any = {
        startDate: null,
        endDate: null,
        digitType: null,
        payService: null
    };
    public txnHeaderSearch: any = {
        id: null,
        createdAt: null,
        riderId: null,
        firstName: null,
        lastName: null,
        amount: null,
        payServiceName: null,
        paidAt: null,
        status: null,
    };
    public first: number = 0;
    public sortField: string | string[] = 'Id';
    private sortOrder: number = -1;
    public loading: boolean = false;
    private searchTimer: number = 0;
    public showDetailTransactionSidebar: boolean = false;
    public selectedTransaction: any;
    public arrayFilterStatuses: any =
    [
        {
            name: 'All', value: null
        },
        {
            name: 'Pending', value: PayoutTransactionOnlineTransferEnum.Pending
        },
        {
            name: 'Cancelled', value: PayoutTransactionOnlineTransferEnum.Cancelled
        },
        {
            name: 'Completed', value: PayoutTransactionOnlineTransferEnum.Completed
        }
    ];

    public cols: any[] = [
        {
            field: 'Id',
            header: 'TX ID',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'Id',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'CreatedAt',
            header: 'Transaction Date',
            width: '10%',
            fieldType: FieldTypeEnum.Calendar,
            model: 'CreatedAt',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'RiderId',
            header: 'Driver ID',
            width: '10%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'riderId',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'FirstName',
            header: 'First Name',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'firstName',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'LastName',
            header: 'Last Name',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'lastName',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'Amount',
            header: 'Amount',
            width: '20%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'amount',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'PayServiceName',
            header: 'Payout Account',
            width: '20%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'payServiceName',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'paidAt',
            header: 'Date Paid',
            width: '10%',
            fieldType: FieldTypeEnum.Calendar,
            model: 'PaidAt',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'Status',
            header: 'Status',
            width: '20%',
            disableSort: false,
            fieldType: FieldTypeEnum.Dropdown,
            model: 'status',
            options: this.arrayFilterStatuses,
            placeholder: 'Please Select',
            active: false,
        }
    ];
    public defaultCols = this.cols.map(x => x);

    menuHomeEnumActive: MenuHomeEnum | undefined;
    $subscription: Subscription | undefined;

    constructor(
        private messageService: MessageService,
        private payoutTransactionService: PayoutTransactionService,
        public configService: ConfigService,
        private menuService: MenuService) {
        this.handleHideTransactionInfo = this.handleHideTransactionInfo.bind(this);
    }

    ngOnInit(): void {
        this.$subscription = this.menuService.menuHomeEnumActive$.subscribe(
            (value) => {
                this.menuHomeEnumActive = value;
            }
        );
    }

    ngOnDestroy(): void {
        this.$subscription?.unsubscribe();
    }

    onSelectedColumnsChange(event: any[]) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    getMenuHomeName(): string {
        return this.onboardingTabMenu.find((item: any) => item.value === this.menuHomeEnumActive).name;
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.getMenuHomeName());
        }

        this.callGridTitles(skip);
    }

    filter: {
        searchName: string;
    } = { searchName: '' };

    handleFilterChange(model: string, event: any): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            if (model === 'Id') {
                this.txnHeaderSearch.id = event.target.value;
            }
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    handleHeaderFilterChange() {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }
        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    getPayoutTransactions(skip: number) {
        const dto = {
            SearchName: this.filter.searchName,
                Id: this.txnHeaderSearch.id ? this.txnHeaderSearch.id : null,
            CreatedAt: this.txnHeaderSearch.CreatedAt ? this.txnHeaderSearch.CreatedAt : null,
            RiderId: this.txnHeaderSearch.riderId ? this.txnHeaderSearch.riderId : null,
            FirstName: this.txnHeaderSearch.firstName ? this.txnHeaderSearch.firstName : null,
            LastName: this.txnHeaderSearch.lastName ? this.txnHeaderSearch.lastName : null,
            Amount: this.txnHeaderSearch.amount ? this.txnHeaderSearch.amount : null,
            Status: this.txnHeaderSearch.status ? this.txnHeaderSearch.status : null,
            PayServiceName: this.txnHeaderSearch.payServiceName ? this.txnHeaderSearch.payServiceName : null,
            PaidAt: this.txnHeaderSearch.PaidAt ? this.txnHeaderSearch.PaidAt : null,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };
        this.loading = true;
        this.payoutTransactionService.getPayoutTransactions(dto, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.first = dto.Skip;
                this.totalRecords = data.TotalRecords;
                this.paginator.Items = [];
                this.paginator.Items.push(...data.Transactions);
                this.payoutTransactions = data.Transactions;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    clickChangeMenuHomeActive(value: MenuHomeEnum) {
        // this.menuHomeEnumActive = value;
        this.menuService.changeMenuHomeEnumActive(value);
        this.handleLazyLoad({
            first: 0,
            rows: this.rowsPerPage
        });
    }

    getStatusName(status: number): string {
        return this.arrayFilterStatuses.find((item: any) => item.value === status).name;
    }

    getPaidAt(transaction: any): string {
        return transaction?.Status === PayoutTransactionOnlineTransferEnum.Completed ? transaction.PaidAt : '';
    }

    getStatusStyles(status: number): StylesStatus {
        let backgroundColor: string;
        let textColor: string;
        switch (status) {
            case PayoutTransactionStatusEnum.Completed:
                backgroundColor = '#E7F7EF';
                textColor = '#1CBA70';
                break;
            case PayoutTransactionStatusEnum.Pending:
                backgroundColor = '#FFEFCC';
                textColor = '#FFB100';
                break;
            case PayoutTransactionStatusEnum.Processing:
                backgroundColor = '#FDEBEA';
                textColor = '#EB4236';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    onSelectionChange(event: any) {
        this.selectedTransaction = event?.data;
    }

    handleHideTransactionInfo() {
        this.showDetailTransactionSidebar = false;
    }

    callGridTitles(skip: number) {
        this.callPayoutTransactions(skip);
    }

    callPayoutTransactions(skip: number) {
        this.getPayoutTransactions(skip);
    }
    onChangeHeaderFilterDropDown(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1000);
    }

    updateEventEmit(value: any) {
        this.callGridTitles(0);
    }

    changedVisibleTransactionsSettingsEmit(value: any) {
        this.visibleTransactionsSettings = value;
    }

    protected readonly OrderUtils = OrderUtils;
}

class Paginator {
    public Loading: boolean = true;
    public TotalRecords: number = 0;
    public Items: Array<any> = [];
    public Skip: number = 0;
    public Take: number = 10;
}
